import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

import {
  USERS_REVIEWS,
  USERS_REVIEWS_LURE,
  USERS_REVIEWS_WITHOUT_DIALOGUE,
} from './constant';
import { UsersReviewsStyles } from './UsersReviews.styles';
import { PaywallUsersReviewsWithDate } from './UsersReviewsWithDate';

const STARS_ARRAY = Array.from({ length: 5 });

export const PaywallUsersReviews: React.FC = () => {
  const paywallNotes = webCampaign.setup.paywallNotes ?? [];

  const removeDialogueReferences = paywallNotes.includes(
    PAYWALL_NOTES.REMOVE_DIALOGUE_REFERENCES,
  );
  const useAppStoreReviews = paywallNotes.includes(
    PAYWALL_NOTES.REVIEWS_APP_STORE,
  );

  const getSelectedReviews = () => {
    if (webCampaign.isPaywallLure()) return USERS_REVIEWS_LURE;
    if (removeDialogueReferences) return USERS_REVIEWS_WITHOUT_DIALOGUE;
    return USERS_REVIEWS;
  };

  const selectedReviews = getSelectedReviews();

  if (useAppStoreReviews) {
    return <PaywallUsersReviewsWithDate />;
  }

  return (
    <UsersReviewsStyles>
      {selectedReviews.map((review) => (
        <div key={review.name} className="paywall-users-reviews-review">
          <UiTypography
            className="paywall-users-reviews-review-author"
            variant="label-medium"
          >
            {review.name}
          </UiTypography>
          <div className="paywall-users-reviews-review-stars">
            {STARS_ARRAY.map((_, idx) => (
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                key={idx}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.09112 2.40659C8.42712 1.59884 9.57312 1.59884 9.90912 2.40659L11.4706 6.16184L15.5236 6.48659C16.3966 6.55634 16.7506 7.64534 16.0854 8.21534L12.9976 10.8606L13.9404 14.8153C14.1436 15.6673 13.2174 16.3401 12.4704 15.8841L9.00012 13.7646L5.52987 15.8841C4.78287 16.3401 3.85662 15.6666 4.05987 14.8153L5.00262 10.8606L1.91487 8.21534C1.24962 7.64534 1.60362 6.55634 2.47662 6.48659L6.52962 6.16184L8.09112 2.40659Z"
                  fill="#FFB55E"
                />
              </svg>
            ))}
          </div>
          <UiTypography
            variant="body-small"
            className="paywall-users-reviews-review-text"
          >
            {review.review}
          </UiTypography>
          {useAppStoreReviews && (
            <UiTypography
              variant="body-small"
              className="paywall-users-reviews-review-source"
            >
              source: AppStore
            </UiTypography>
          )}
        </div>
      ))}
    </UsersReviewsStyles>
  );
};
